import {TimeagoClock, TimeagoFormatter} from 'ngx-timeago';
import {interval, Observable} from 'rxjs';

// Format a given timestamp as elapsed minutes and seconds, or (if more than an hour), hours, minutes, and seconds.
export class ElapsedFormatter extends TimeagoFormatter {
  format(then: number): string {
    if (then) {
      // console.log(new Date(then).toLocaleString());
      const duration = (new Date().getTime() - then) / 1000;
      const elapsedSeconds = Math.floor(duration % 60);
      const elapsedMinutes = Math.floor((duration / 60) % 60);
      const elapsedHours = Math.floor((duration / 60 / 60) % 24);
      if (elapsedHours) {
        return `${this.padNumbers_(elapsedHours)}:${this.padNumbers_(elapsedMinutes)}:${this.padNumbers_(elapsedSeconds)}`;
      }
      return `${this.padNumbers_(elapsedMinutes)}:${this.padNumbers_(elapsedSeconds)}`;
    }
  }

  private padNumbers_(value: number): string {
    return value < 10 && value >= 0 ? '0' + value : value.toString();
  }

}

// Use a clock that ticks once a second to update UI
export class ElapsedClock extends TimeagoClock {
  tick(then: number): Observable<any> {
    return interval(1000);
  }
}
